<template>
  <div>
    <label v-if="label">{{ label }}</label>
    <AppSelect
      v-model="selected"
      async
      :options="options"
      :select2-options="select2Options"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesBaseSelectFilter',
  props: {
    label: {
      type: String,
    },
    queryProperty: {
      type: String,
      required: true,
    },
    queryFilter: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    allowClear: {
      type: Boolean,
      default: true,
    },
    defaultOption: {
      type: String
    }
  },
  data() {
    return {
      select2Options: {
        width: '100%',
        multiple: this.multiple,
        allowClear: this.allowClear,
        placeholder: this.placeholder,
      },
    };
  },
  computed: {
    ...mapGetters(['timeEntriesQuery']),
    selected: {
      get() {
        const currentValue = this.queryFilter
          ? this.timeEntriesQuery.filters[this.queryProperty]
          : this.timeEntriesQuery[this.queryProperty];

        return currentValue || this.initialOption;
      },
      set(queryValue) {
        this.$store.dispatch('updateSearch', { filters: { [this.queryProperty]: queryValue } });
        this.$emit('filter-change', { [this.queryProperty]: queryValue });
      },
    },
    initialOption() {
      return this.multiple ? [] : this.defaultOption;
    },
  },
};
</script>
